<template>
  <div class="admin-tool-bar">
    <div class="admin-tool-bar__body">
      <admin-tool-bar-title />
      <admin-tool-bar-links
        :links="links"
      />
    </div>
  </div>
</template>

<script>
import { adminToolBarLinks } from '@/mikan/_shared/types/vueTypes/adminToolBarLink';
import AdminToolBarTitle from '@/mikan/pc/components/molecules/AdminToolBarTitle.vue';
import AdminToolBarLinks from '@/mikan/pc/components/molecules/AdminToolBarLinks.vue';

export default {
  components: {
    AdminToolBarTitle,
    AdminToolBarLinks,
  },
  props: {
    links: adminToolBarLinks.def(() => []),
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/pc/base/constants';

.admin-tool-bar {
  background-color: $color-navy-70;

  &__body {
    display: flex;
    width: $full-width;
    align-items: center;
    justify-content: space-between;
    padding: 4px $global-gutter 4px;
    margin: 0 auto;
  }
}
</style>
